import React, { useEffect, useState } from 'react';
import './B2BOrders.css';

/**
 * A confirm dialog, optionally capturing a reason.
 *
 * Replaces `window.prompt`/`window.confirm`, which render as the browser's own
 * chrome — unstyled, pinned to the top of the screen, and captioned with the
 * origin ("localhost:3001 says"). It also blocks the main thread, so nothing
 * behind it can paint while it is open.
 *
 * Shared by the order delete and the shipment removal: both ask the same
 * question, and one component keeps them phrased and styled alike.
 */
export default function B2BConfirmModal({
  title,
  body,
  confirmLabel = 'Confirm',
  danger = false,
  withReason = false,
  reasonLabel = 'Reason (optional)',
  busy = false,
  onConfirm,
  onClose,
}) {
  const [reason, setReason] = useState('');

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape' && !busy) onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose, busy]);

  return (
    <div
      className="b2bModalBackdrop b2bConfirmBackdrop"
      role="dialog"
      aria-modal="true"
      onClick={() => {
        if (!busy) onClose();
      }}
    >
      <div
        className="b2bModalPanel b2bConfirmPanel"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="b2bModalHead">
          <h3>{title}</h3>
        </header>

        <div className="b2bModalBody">
          {body && <p className="b2bConfirmBody">{body}</p>}

          {withReason && (
            <label className="field">
              <span>{reasonLabel}</span>
              <input
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                // The dialog exists to be answered, so the caret starts here.
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !busy) onConfirm(reason);
                }}
              />
            </label>
          )}
        </div>

        <footer className="b2bModalFoot">
          <button
            type="button"
            className="btn btnGhost"
            onClick={onClose}
            disabled={busy}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`btn ${danger ? 'b2bBtnDanger' : 'btnPrimary'}`}
            onClick={() => onConfirm(reason)}
            disabled={busy}
          >
            {busy ? 'Working…' : confirmLabel}
          </button>
        </footer>
      </div>
    </div>
  );
}
